<template>
  <main v-loading="loading">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: './visa' }">签证</el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{
        path: './visa_list',
        query: { id: info.CountryID, detailId: info.VisaProductID },
      }">签证详情</el-breadcrumb-item> -->
      <el-breadcrumb-item>签证详情</el-breadcrumb-item>
      <el-breadcrumb-item>提交订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-steps :active="1" simple>
      <el-step title="提交订单" icon="el-icon-edit"></el-step>
      <el-step title="在线支付" icon="el-icon-connection"></el-step>
      <el-step title="完成" icon="el-icon-chat-line-round"></el-step>
    </el-steps>
    <section v-show="showPaymentMethod">
      <h4>结算方式</h4>
      <el-radio-group v-model="submit.paymentMethod">
        <el-radio v-for="v in paymentMethods" :key="v.value" :label="v.value">{{
          v.label
        }}</el-radio>
      </el-radio-group>
    </section>
    <section class="order">
      <h4>订单信息</h4>
      <el-table :data="order">
        <el-table-column prop="name" label="套餐内容"></el-table-column>
        <el-table-column align="center" prop="day" label="出行日期"></el-table-column>
        <el-table-column align="center" label="单价/元">
          <template slot-scope="s">
            <!-- {{ order[submit.paymentMethod] }} -->
            {{ s.row[submit.paymentMethod] }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="count" label="数量"></el-table-column>
        <el-table-column align="right" label="合计">
          <template>
            <span class="bold">{{ getOrderPrice }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <figure>
        <p>
          <span class="title">保险：</span>
          <el-switch :disabled="ins.length === 0" v-model="switchs.ins" />
        </p>
        <el-table :data="ins" v-show="switchs.ins" @row-click="insRowSelected">
          <el-table-column width="30">
            <template slot-scope="s">
              <el-radio v-model="submit.insId" :label="s.row.VisaInsID"></el-radio>
            </template>
          </el-table-column>
          <el-table-column label="保险名称">
            <template slot-scope="s">
              <span class="link" @click.stop="showInsDesc(s.row)">{{
                s.row.Name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" width="120" label="单价(元)">
            <template slot-scope="s">
              <span class="bold">{{ s.row.Price }}</span>
            </template>
          </el-table-column>
        </el-table>
        <ul v-show="switchs.ins" class="data">
          <li>
            <span>保险期限：</span>
            <el-date-picker v-model="submit.insDate" type="daterange" :picker-options="insDateOptions"
              value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </li>
          <li>
            <span>保险份数：</span>
            <el-input-number v-model="submit.insCount" :min="1"></el-input-number>
          </li>
        </ul>
      </figure> -->
      <figure class="people">
        <p>联系人</p>
        <ul class="data">
          <li>
            <span>姓名：</span>
            <el-input v-model="submit.CustomerName"></el-input>
          </li>
          <li>
            <span>手机号：</span>
            <el-input v-model="submit.Moblie"></el-input>
          </li>
          <!-- <li>
            <span>公司名称：</span>
            <el-input v-model="submit.company_name"></el-input>
          </li>
          <li>
            <span>公司地址：</span>
            <el-input v-model="submit.customer_address"></el-input>
          </li>
          <li>
            <span>推荐人：</span>
            <el-input v-model="submit.referrer"></el-input>
          </li> -->
          <li>
            <span>备注：</span>
            <el-input v-model="submit.remark"></el-input>
          </li>
        </ul>
      </figure>
      <!-- <figure class="people">
        <p>签证申请人：</p>
        <ul class="data">
          <li class="max">
            <span>姓名：</span>
            <el-input placeholder="输入完成后，回车添加申请人" v-model="submit.people" @change="addPeoplesTag"></el-input>
            <div class="tags" v-show="submit.peoples.length > 0">
              <el-tag closable @close="closePeopleTag(i)" type="info" v-for="(v, i) in submit.peoples" :key="i">{{ v
              }}</el-tag>
            </div>
          </li>
        </ul>
      </figure> -->

    </section>
    <!-- <section class="post">
      <h4>签证提取</h4>
      <dl>
        <dt>
          <el-radio v-model="submit.delivery" :label="true">邮寄</el-radio>
          <el-radio v-model="submit.delivery" :label="false">自取</el-radio>
          <p class="hint">
            （注：快递费需自付，如需线上支付快递费，请勾选邮寄，选择"资料邮寄"、"签证回邮"，广东省内<b>13</b>，非广东省<b>23</b>。）
          </p>
        </dt>
        <dd v-show="submit.delivery">
          <figure>
            <el-checkbox v-model="submit.deliveryMail">资料邮寄</el-checkbox>
            <el-table :data="address" v-show="submit.deliveryMail"
              @row-click="(row) => changeDelivery(row, 'deliveryMailId')">
              <el-table-column width="30">
                <template slot-scope="s">
                  <el-radio v-model="submit.deliveryMailId" :label="s.row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="addressee" width="150" label="收件人"></el-table-column>
              <el-table-column prop="phone" width="150" label="手机号码"></el-table-column>
              <el-table-column label="详细地址">
                <template slot-scope="s">
                  {{ s.row | getAddressDesc }}
                </template>
              </el-table-column>
            </el-table>
          </figure>
          <figure>
            <el-checkbox v-model="submit.deliveryReply">资料回邮</el-checkbox>
            <el-table :data="address" v-show="submit.deliveryReply"
              @row-click="(row) => changeDelivery(row, 'deliveryReplyId')">
              <el-table-column width="30">
                <template slot-scope="s">
                  <el-radio v-model="submit.deliveryReplyId" :label="s.row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="addressee" width="150" label="收件人"></el-table-column>
              <el-table-column prop="phone" width="150" label="手机号码"></el-table-column>
              <el-table-column label="详细地址">
                <template slot-scope="s">
                  {{ s.row | getAddressDesc }}
                </template>
              </el-table-column>
            </el-table>
          </figure>
        </dd>
        <dd></dd>
      </dl>
    </section> -->
    <!-- <section class="serve">
      <h4>增值服务</h4>
      <figure class="invoice">
        <p>
          <span class="title">发票：</span>
          <el-switch v-model="switchs.invoice" />
          <span class="hint">温馨提示：发票金额不包含使用积分支付的部分，我公司依法开具发票，如您的商品按税法规定不得从增值税销项税额中抵扣的项目（例如集体福利或个人消费）</span>
        </p>
        <ul v-show="switchs.invoice" class="data">
          <li>
            <span>发票抬头：</span><el-input v-model="submit.invoiceTitle"></el-input>
          </li>
          <li>
            <span>纳税人识别码：</span><el-input v-model="submit.invoiceCode"></el-input>
          </li>
        </ul>
      </figure>
    </section> -->
    <!-- <section class="coupon" v-show="coupon.length > 0">
      <h4>可用优惠券</h4>
      <ul>
        <li v-for="(v, i) in coupon" :key="v.id" @click="couponIndex = i">
          <figure>
            <p class="price">
              <span>{{ v.amount }}</span>
              <span>满{{ v.min_consumption }}可用</span>
            </p>
            <p class="info">
              <span class="title">{{ v.title }}</span>
              <span class="desc">有效期至：{{ v.use_edate }}</span>
            </p>
          </figure>
          <i class="icon-gou" :class="{ on: couponIndex === i }"></i>
        </li>
      </ul>
    </section> -->

    <!-- 办理信息 -->
    <section class="orderFieldForm">
      <order-field-form ref="orderFieldForm" :requireFieldOptionList="requireFieldOption"
        :pickerInner="order[0].day"></order-field-form>
    </section>


    <section class="otherWrap" v-if="userInfo && userInfo.identify && userInfo.identify.includes('staff')">
      <div class="otherTop">
        <h4>其他费用 </h4>
        <el-button icon="el-icon-circle-plus" size="small" type="primary" @click="addExtraData">添加</el-button>
      </div>
      <el-table :data="extraTableData" border style="width: 100%">

        <el-table-column label="项目">
          <template slot-scope="slot">
            <el-select v-model="slot.row.fees_class_id" placeholder="请选择">
              <el-option v-for="item in visa_fees" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="单价">
          <template slot-scope="slot">
            <el-input type="number" v-model="slot.row.unit_price" placeholder="请输入单价" step="1" precision="2"
              clearable></el-input>
          </template>
        </el-table-column>

        <el-table-column label="数量">
          <template slot-scope="slot">
            <el-input-number v-model="slot.row.quantity" @change="handleChange" :precision="0" :min="1"
              label="描述文字"></el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="备注">
          <template slot-scope="slot">
            <el-input type="textarea" rows="2" placeholder="请输入内容" v-model="slot.row.remark">
            </el-input>
          </template>
        </el-table-column>

        <el-table-column label="更多操作" align="right" width="100">
          <template slot-scope="slot">
            <el-button type="danger" icon="el-icon-delete" size="small"
              @click="deleteExtraItem(slot.$index)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <figure class="addupExtraInfo" v-if="extraTableData && extraTableData.length">
        <figcaption><span>合计</span>:￥{{ sumExtraPrice }}</figcaption>
      </figure>
    </section>

    <section class="pay">
      <figure>
        <p>
          <span>订单费用：</span><b>{{ getOrderPrice }}</b>
        </p>
        <!-- <p>
          <span>邮寄费用：</span><b>{{ getDeliveryPrice }}</b>
        </p>
        <p>
          <span>保险费用：</span><b ref="insPrice">{{ getInsPrice }}</b>
        </p>
        <p>
          <span>优惠券抵扣：</span><b>{{ getCouponPrice }}</b>
        </p> -->
        <p>
          <span>总计：</span><b>{{ getPayPrice }}</b>
        </p>
      </figure>
      <div class="btn">
        <el-checkbox v-model="switchs.protocol">同意（我清楚，出签之前预定机票和酒店的风险，并愿意自行承担。）</el-checkbox>
        <el-button type="danger" round="" @click="addOrder">提交订单</el-button>
      </div>
    </section>

    <el-dialog :title="insDesc.title" :visible.sync="insDesc.show" width="800px">
      {{ insDesc.desc }}
    </el-dialog>
  </main>
</template>

<script>
import { Message } from "element-ui";
import $strategy from "@assets/js/strategy";
import $user from "@api/user";
import $coupon from "@api/coupon";
import $visa from "@api/visa";
import $orderPro from '@api/orderPro';
import moment from "moment";
import { mapState } from "vuex";
import tool from '@assets/js/tool';
import orderFieldForm from './component/orderFieldForm';

export default {
  components: {
    orderFieldForm
  },
  data() {
    return {
      visa_fees: [],//其他 栏目的下拉参数
      extraTableData: [],//其他 附加费用
      loading: true,
      info: {},
      order: [], // 套餐信息
      ins: [], // 保险列表
      insDesc: {
        show: false,
        title: null,
        desc: null,
      },
      insDateOptions: {
        disabledDate: (date) => {
          const [item] = this.order;
          const { day } = item;
          return Date.parse(date) < Date.parse(day);
        },
      },
      // 开关
      switchs: {
        ins: false,
        invoice: false,
        protocol: false,
      },
      submit: {
        insId: null, // 保险id
        insDate: null, // 保险期限
        insCount: 1, // 保险份数
        delivery: false, // 配送方式
        deliveryMail: false, // 资料邮寄
        deliveryMailId: null, // 地址ID
        deliveryReply: false, // 资料回邮
        deliveryReplyId: null, // 地址ID
        invoiceTitle: null, // 发票抬头
        invoiceCode: null, // 纳税人识别码
        peoples: [], // 已添加的申请人
        people: null, // 申请人输入值
        remark: null, // 备注
        CustomerName: null, // 申请人姓名
        Moblie: null, // 申请人手机
        company_name: null, // 公司名称
        customer_address: null, // 公司地址
        referrer: null, // 推荐人
        // paymentMethod: null, // 结算方式
        paymentMethod: 'retail_price', // 结算方式
      },
      address: [],
      // 结算方式
      paymentMethods: [
        // { value: "CustomerPrice", label: "VIP" },
        // { value: "BigCreditPayment", label: "企业VIP" },
        // { value: "TradePrice", label: "分销现结" },
        // { value: "SmallCreditPaymen", label: "分销后结" },
        { value: "dealer_price", label: "分销商价" },
        { value: "retail_price", label: "零售价" },
      ],
      coupon: [],
      couponIndex: 0,
      requireFieldOption: [],
      fieldOptionChecked: false, //必填信息的校验状态 默认false，[ 无必填信息时，需要默认为true ]
    };
  },
  async created() {
    let _this = this;
    let { order, ins = [], day, count, info } = this.$route.params;
    // 2025-03-26 通过spu信息内的order_required_ids,判断是否需要增加额外的办理信息表单
    const { order_required_ids } = info;
    if (order_required_ids && order_required_ids.length) {

      $orderPro.getOrderFieldOptions(order.id).then((res) => {
        if (res.status == "success") {
          const { data } = res;
          _this.requireFieldOption = data;
        }
      })

    } else {
      console.log("-----无办理信息填写内容-----")
    }


    // 无效路径
    if ($strategy.check(order, "isEmpty")) {
      this.$router.push({ name: "visa" });
      return;
    }

    // TODO: 此处需要一个条件判断,如果有存储用户的账号密码，则进行静默登录,否则需要跳转到登录界面重新登录;

    // 此处的重新获取产品信息
    if (!order.dealer_price || order.dealer_price == 0) {

      await $user.checkLogin().then((res) => {
        if ("success" in res) {
          _this.updateUserInfo(res);

          $visa.getVisaProductDetail(info.id).then((res) => {
            const currentSkuId = order.id;
            let filterOrderInfo = res.data.skus.find((item) => { return item.id == currentSkuId });
            const new_dealer_price = _this.setNormalPrice(filterOrderInfo.dealer_price || 0);
            const new_retail_price = _this.setNormalPrice(filterOrderInfo.retail_price || 0);
            order.dealer_price = new_dealer_price;
            order.retail_price = new_retail_price;
            // TODO:此处只更新价格，不更新其他内容(防止替换了不必要替换的参数导致页面报错)
            info = res.data.spu;

            _this.order = [{ ...order, day, count }];
            _this.info = info;

            // 通过身份判断,需要默认显示的是 分销商价/ 零售价
            const hasDealerPriceList = ['distribution', 'staff', 'partner'];
            if (_this.userInfo && _this.userInfo.identify && hasDealerPriceList.includes(_this.userInfo.identify)) {
              _this.submit.paymentMethod = 'dealer_price';
            }
          });

        } else {
          // 未检测到有登录状态时则直接跳转到登录界面
          this.$router.push({ name: "login" });
          return;
        }
      })
    } else {
      _this.order = [{ ...order, day, count }];
      _this.info = info;
    }


    // 获取并设置 其他相关的下拉分类数据
    $orderPro.getVisaFees().then((res) => {
      if (res && res.visa_fees) {
        let optionList = [];
        res.visa_fees.map((item) => {
          optionList.push({ label: item.text, value: item.id })
        })
        _this.visa_fees = optionList;
      }
    })

    const address = await $user.getAddress();
    this.ins = ins;
    this.address = address;
    this.loading = false;
    const { contact_name, customerMobile } = this.getUserInfo();
    this.submit = {
      ...this.submit,
      CustomerName: contact_name,
      Moblie: customerMobile,
      // paymentMethod: this.getPriceName(),
      paymentMethod: 'retail_price'
    };
    // 优惠券
    // const coupon = await $coupon.use({
    //   amount: this.getTotalPrice,
    //   product_id: info.VisaProductID,
    // });
    // this.coupon = coupon;

    // 通过身份判断,需要默认显示的是 分销商价/ 零售价
    const hasDealerPriceList = ['distribution', 'staff', 'partner'];
    if (_this.userInfo && _this.userInfo.identify && hasDealerPriceList.includes(_this.userInfo.identify)) {
      _this.submit.paymentMethod = 'dealer_price';
    }

  },
  filters: {
    getAddressDesc(addr) {
      const { province, city, district, address } = addr;
      return `${province + city + district + address}`;
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    // 合计 其他费用
    sumExtraPrice() {
      let _this = this;
      let sumExtraNumber = 0;

      _this.extraTableData.map((item) => {
        if (item.unit_price) {
          item.unit_price = Number(Number(item.unit_price).toFixed(2))
        }
        if (item.unit_price && item.quantity) {
          sumExtraNumber += Number(item.unit_price) * Number(item.quantity)
        }
      })
      return sumExtraNumber;
    },
    getPayPrice() {
      return Number(this.getTotalPrice - this.getCouponPrice + this.sumExtraPrice).toFixed(2);
    },
    getCouponPrice() {
      const { coupon, couponIndex } = this;
      if (coupon.length === 0) {
        return 0;
      }
      return Number(coupon[couponIndex].amount);
    },
    showPaymentMethod() {
      const { identify } = this.userInfo;
      const arr = ["staff", "partner", "distribution"];
      return arr.includes(identify);
    },
    getTotalPrice() {
      const { getDeliveryPrice, getOrderPrice, getInsPrice } = this;
      return `${Number(getDeliveryPrice) + Number(getOrderPrice) + Number(getInsPrice)
        }`;
    },
    // 获取邮寄费用
    getDeliveryPrice() {
      const { submit, address } = this;
      let count = 0;
      const { deliveryMail, deliveryMailId, deliveryReply, deliveryReplyId } =
        submit;
      if (deliveryMail && deliveryMailId) {
        const addr = address.find((v) => v.id === deliveryMailId);
        count += addr.province === "广东省" ? 13 : 23;
      }
      if (deliveryReply && deliveryReplyId) {
        const addr = address.find((v) => v.id === deliveryReplyId);
        count += addr.province === "广东省" ? 13 : 23;
      }
      return count;
    },
    // 获取订单费用
    getOrderPrice() {
      const [order] = this.order;
      if (!order) {
        return "--";
      }
      const { count, TradePrice } = order;
      const { paymentMethod } = this.submit;
      return (Number(order[paymentMethod]) * Number(count)).toFixed(2);
    },
    // 获取保险费用
    getInsPrice() {
      const { submit, ins, switchs } = this;
      const { insCount, insId, insDate } = submit;
      let price = 0;
      if (switchs.ins && insId && insDate) {
        const insInfo = ins.find((v) => v.VisaInsID === insId);
        const [startDate, endDate] = insDate;
        const startTime = moment(startDate);
        const endTime = moment(endDate);
        const day = endTime.diff(startTime, "days") + 1;
        price += insCount * Number(insInfo.Price) * day;
      }
      return price;
    },
  },
  methods: {
    setNormalPrice(price) {
      return tool.ConversionPrice(price)
    },

    // 删除一行数据
    deleteExtraItem(index) {
      this.extraTableData.splice(index, 1)
    },
    // 添加一行其他数据
    addExtraData() {
      this.extraTableData.push({
        fees_class_id: null,
        quantity: 1,
        remark: '',
        unit_price: 0
      })
    },
    handleChange(e) {
    },
    test(value) {
      this.submit = { ...this.submit, paymentMethod: value };
    },
    showInsDesc(item) {
      const { Name, Desc } = item;
      this.insDesc = { ...this.insDesc, show: true, title: Name, desc: Desc };
    },
    // 检测其他费用模块信息的完整性
    checkOtherExtraPrice() {
      let _this = this;
      let checkStatus = false;
      if (!_this.extraTableData.length) return true;

      for (let i in _this.extraTableData) {
        if (!_this.extraTableData[i].fees_class_id) {
          Message.error('其他费用第' + (Number(i) + 1) + '项的项目必选！');
          break;
        }
        if (!_this.extraTableData[i].unit_price) {
          Message.error('其他费用第' + (Number(i) + 1) + '项的单价必填！');
          break;
        }
        if (!_this.extraTableData[i].quantity) {
          Message.error('其他费用第' + (Number(i) + 1) + '项的数量必填！');
          break;
        }
        checkStatus = true;
      }

      return checkStatus;
    },
    // 提交订单
    addOrder() {
      let _this = this;
      const fieldsFormData = _this.$refs.orderFieldForm.getFormDatas();
      if (!Object.keys(fieldsFormData).length) return;
      if (!fieldsFormData.checkedStatus) return;

      // 订单必填信息数据
      const orderFieldFormData = fieldsFormData.data;

      const { protocol } = this.switchs;
      if (!protocol) {
        this.$message.warning("请勾选预定酒店和机票风险须知。");
        return;
      }
      // const { invoice } = this.switchs;
      // // 检测保险
      // if (this.checkInsState() === false) {
      //   return;
      // }
      // // 检查联系人
      // const { CustomerName, Moblie } = this.submit;
      // if (
      //   $strategy.check(CustomerName, "isEmpty") ||
      //   $strategy.check(Moblie, "isMobile") === false
      // ) {
      //   this.$message.warning("联系人信息有误，请检查！");
      //   return;
      // }
      // // 检查发票
      // if (invoice) {
      //   const { invoiceCode, invoiceTitle } = this.submit;
      //   if (
      //     $strategy.check(invoiceCode, "isEmpty") ||
      //     $strategy.check(invoiceTitle, "isEmpty")
      //   ) {
      //     this.$message.warning("请检查发票信息，如不需要发票，请关闭选项！");
      //     return;
      //   }
      // }
      // // 检查邮寄
      // if (this.checkDelivery() === false) {
      //   return;
      // }
      // 校验 其他费用模块
      if (!_this.checkOtherExtraPrice()) return;

      const orderInfo = this.order[0];
      const otherFees = _this.extraTableData; //额外附加费用 (其他)


      const OrderUnitPrice = orderInfo[this.submit.paymentMethod];//套餐单价 
      const count = orderInfo.count; //购买数量
      const skuSumPrice = Number(OrderUnitPrice) * Number(count); //套餐金额
      let sumOtherPrice = 0;//其他费用 总金额
      if (otherFees && otherFees.length) {
        otherFees.map((item) => {
          const rowPrice = Number(item.unit_price) * Number(item.quantity);
          sumOtherPrice += rowPrice;
        })
      }
      if (sumOtherPrice < 0 && Math.abs(sumOtherPrice) > skuSumPrice) {
        this.$message.warning("订单价格不能为负数！");
        return;
      }

      const remark = this.submit.remark || '';

      let x_OrderInfo = {
        contact_name: this.submit.CustomerName,
        contact_phone: this.submit.Moblie,
        sku_id: orderInfo.id,
        sku_quantity: orderInfo.count,
        sku_travel_date: orderInfo.day,
        price_field_name: this.submit.paymentMethod,
        otherFees: otherFees,
        remark: remark,
      }

      //2025-03-26 下单时，增加 部分必填表单内容
      if (orderFieldFormData && Object.keys(orderFieldFormData).length) {
        x_OrderInfo = { ...x_OrderInfo, ...orderFieldFormData };
      }
      $visa
        .create_Xorder(x_OrderInfo)
        .then((res) => {
          if (res.status == 'fail') {
            Message.error(res.message);
            return;
          }
          const { order_sn } = res.data;
          // 跳转到新版本订单支付界面
          this.$router.push({ name: "order_payment", query: { order_sn } });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
      return;
      const data = this.getRequestData();

      this.loading = true;
      $visa
        .addOrder(data)
        .then(({ OK: orderNo }) => {
          this.$router.push({ name: "order_pay", query: { orderNo } });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取添加订单的参数
    getRequestData() {
      const {
        FormName,
        KindName,
        VisaProductID: ProductID,
        Name: ProductName,
      } = this.info;
      const { textContent: InsAmount } = this.$refs.insPrice;
      const [order] = this.order;
      const { day: UserDateTime } = order;
      const {
        insId,
        CustomerName,
        Moblie,
        deliveryMailId: is_express_data,
        deliveryReplyId: is_post_back,
        company_name,
        customer_address,
        referrer,
        paymentMethod,
      } = this.submit;
      let data = {
        CustomerName,
        FormName,
        InsAmount: Number(InsAmount),
        KindName,
        Moblie,
        ProductID,
        ProductName,
        UserDateTime,
        company_name,
        customer_address,
        referrer,
        VisaOrderIns: insId ? this.getInsInfo() : null,
        express_data_amount: is_express_data
          ? this.getAddressPrice(is_express_data)
          : null,
        is_express_data,
        post_back_amount: is_post_back
          ? this.getAddressPrice(is_post_back)
          : null,
        is_post_back,
        priceName: paymentMethod,
        visaAmount: this.getTotalPrice,
        visaOrderPackage: this.getOrderPackage(),
        order_source: 0,
      };
      const { coupon, couponIndex } = this;
      coupon.length > 0 && (data.coupon_sn = coupon[couponIndex].coupon_sn);
      return data;
    },
    // 获取套餐信息
    getOrderPackage() {
      const [order] = this.order;
      const { paymentMethod } = this.submit;
      const {
        Id: VisaPriceId,
        Name: VisaPriceName,
        TradePrice: amount,
        count: quantity,
      } = order;
      return {
        VisaPriceId,
        VisaPriceName,
        amount,
        quantity,
        unitPrice: order[paymentMethod],
      };
    },
    // 获取保险信息
    getInsInfo() {
      const { insCount: BuyNums, insDate, insId } = this.submit;
      const [BeginDate, EndDate] = insDate;
      const ins = this.ins.find((v) => v.VisaInsID === insId);
      const {
        CostPrice: InsCostPrice,
        Desc: InsDesc,
        Name: InsName,
        Price: InsPrice,
        VisaInsID,
        VisaInsPriceUnit,
      } = ins;
      const day = moment(EndDate).diff(moment(BeginDate), "days") + 1;
      return {
        BeginDate,
        EndDate,
        BuyNums,
        InsCostPrice,
        InsDesc,
        InsName,
        InsPrice,
        TotalAmount: Number((Number(InsPrice) * BuyNums * day).toFixed(2)),
        VisaInsID,
        VisaInsPriceUnit,
      };
    },
    // 获取地址信息
    getAddressPrice(id) {
      const { address } = this;
      const info = address.find((v) => v.id === id);
      return info.province === "广东省" ? 13 : 23;
    },
    // 检查邮寄
    checkDelivery() {
      const {
        delivery,
        deliveryMail,
        deliveryMailId,
        deliveryReply,
        deliveryReplyId,
      } = this.submit;
      if (delivery) {
        if (deliveryMail === false && deliveryReply === false) {
          this.$message.warning(
            "“资料邮寄”与“资料回邮”必须选择一项，如不需要邮寄，请选择自取！"
          );
          return false;
        }
        if (deliveryMail && deliveryMailId === null) {
          this.$message.warning("请选择资料邮寄的地址选项！");
          return false;
        }
        if (deliveryReply && deliveryReplyId === null) {
          this.$message.warning("请选择资料回邮的地址选项！");
          return false;
        }
      }
      return true;
    },
    // 检查保险状态
    checkInsState() {
      const { ins } = this.switchs;
      const { insDate, insId } = this.submit;
      if (ins) {
        if (insId === null) {
          this.$message.warning("请选择保险!");
          return false;
        }
        if (insDate === null) {
          this.$message.warning("请选择保险期限!");
          return false;
        }
      }
      return true;
    },
    insRowSelected(row) {
      this.updateSubmit("insId", row.VisaInsID);
    },
    // 更新submit
    updateSubmit(attr, value) {
      let submit = { ...this.submit };
      submit[attr] = value;
      this.submit = submit;
    },
    closePeopleTag(index) {
      let peoples = [...this.submit.peoples];
      peoples.splice(index, 1);
      this.updateSubmit("peoples", peoples);
    },
    addPeoplesTag(value) {
      if (!value) {
        return;
      }
      let peoples = [...this.submit.peoples];
      peoples.push(value);
      this.submit = { ...this.submit, peoples, people: null };
    },
    // 修改签证提取地址选项
    changeDelivery(row, attr) {
      const { id } = row;
      this.updateSubmit(attr, id);
    },
  },
};
</script>


<style>
@media only screen and (max-width: 480px) {
  .el-step.is-simple .el-step__title {
    font-size: 14px !important;
  }



}
</style>

<style scoped src="./add.css"></style>
